<mat-dialog-content
  class="mat-typography bg-background dark:bg-dark-background flex justify-center items-center h-full">
  <div class="p-6  flex flex-col justify-center items-center mt-4">
    <lucide-angular [name]="icon" [ngClass]="{'loader spin-slow ': icon === 'loader'}"
      class="text-emerald-500 w-[64px] h-[64px] mb-4"></lucide-angular>
    <p class="text-gray-700 text-lg text-center dark:text-white">{{ text }}</p>
  </div>
</mat-dialog-content>
